// this file added for individual by Bearer Web Developer
import React from 'react';
import styles from './hearAboutBearer.module.scss';
import { useAppState } from '../../../states/app-state';
import { Button } from '@mui/material';
import { observer, Observer } from 'mobx-react-lite';
import klaviyo from '../../../states/klaviyo';
import getToday from '../../../states/klaviyo/getToday';
import { analytics, auth, getRemoteConfigData } from '../../../api/bearer-api';
import { logEvent } from 'firebase/analytics';
import ReactPixel from 'react-facebook-pixel'; // added by Bearer Web Developer
import { SigninSituation } from '../../../states/signinState';
import BearerTextField from '../../../components/fields/BearerTextField';
import data from './data.json';
import { InviteMethod } from '../../../states/newCustomerState';

const HearAboutBearer: React.FunctionComponent = observer(() => {
    const appState = useAppState();
    const { signin, newCustomer, login } = appState;
    const { setActiveInviteMethod, inviteMethod, setInviteCode, inviteCode } = newCustomer;
    function checkvalidation() {
        return !!(inviteMethod && (inviteMethod?.title === "Referral Code" ? inviteCode : true))
    }
    const handleCLick = (data: InviteMethod) => {
        setActiveInviteMethod(data);
    }
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // given_name, last_name, email_address, avatar_url, birth_date, gender,referred_by,
        if (checkvalidation()) {
            try {
                signin.setLoading(true);
                const result = await newCustomer.signupNewCustomer();
                if (result && result?.code === 200 && signin?.uid) {
                    // klaviyo event start Signup (Profile Completed) -> Sign Up Completed
                    await klaviyo.createOrUpdateProfile({
                        type: 'profile',
                        attributes: {
                            email: newCustomer?.email_address,
                            properties: {
                                phone_number: auth?.currentUser?.phoneNumber || '',
                                first_name: newCustomer?.given_name,
                                last_name: newCustomer?.last_name,
                                gender: newCustomer?.gender,
                                dob: newCustomer?.birth_date,  // FORMAT YYYY-MM-DD 
                                user_type: 'Individual',
                                loyalty_tier: "Basic",
                                sign_up_date: getToday(), // Today FORMAT YYYY-MM-DD
                                is_profile_completed: true,
                                referred_by: newCustomer?.referredBy?.toUpperCase() || "Early Adopter",
                                platform_type: 'web',
                                external_id: signin?.uid?.slice(-7) || ''
                            }
                        },
                    });
                    // klaviyo client subscription create profile added by Bearer Web Developer start
                    await klaviyo?.createClientSubscription({
                        email: newCustomer?.email_address,
                        phone_number: auth?.currentUser?.phoneNumber || '',
                    });
                    // klaviyo client subscription create profile added by Bearer Web Developer end
                    await klaviyo.createEvent({
                        event: "Sign Up Completed",
                        email: newCustomer?.email_address
                    });
                    // klaviyo event end Signup (Profile Completed) -> Sign Up Completed
                    // Firebase Analytics Event Name Signup (Profile Completed) added by Bearer Web Developer start
                    // App Event User Details Submitted Successfully. -  REGISTRATION COMPLETE
                    logEvent(analytics, "sign_up_completed", {
                        method: "Ggl.F.B. Ph.V.",
                        user_type: "Individual"
                    })
                    // Firebase Analytics Event Name Signup (Profile Completed) added by Bearer Web Developer end
                    // Event Facebook – Pixel – Meta added by Bearer Web Developer start
                    // Event Facebook Name Signup (Profile Completed) -> CompleteRegistration (Facebook Ads default event)
                    const { environmentCode } = await getRemoteConfigData();
                    if (environmentCode === "PRODUCTION") {
                        ReactPixel.trackSingle('559422939596501', 'CompleteRegistration'); // For tracking custom events.
                    }
                    // Event Facebook – Pixel – Meta added by Bearer Web Developer end
                    await login.loadState(signin?.uid);
                }
                signin.setLoading(false);
                login.setOpen(false);
            } catch (error) {
                console.log(error);
                signin.setLoading(false);
            }
        }
    }
    const handleClose = async () => {
        signin.setSituation(SigninSituation.ReadyForSignup);
    }

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <h2>Personal Details</h2>
                <Button className={styles.back} disableRipple={true} onClick={handleClose}>
                    <img src="/back.png" alt="back" />
                </Button>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
                <p>How did you hear about bearer?</p>
                <ul>
                    {data.map((known, i) => (
                        <li key={i} onClick={() => handleCLick(known as InviteMethod)}
                            className={known?.id === inviteMethod?.id ? styles.active : ''}>
                            <div className={styles.circle}>
                                <img src={`${known?.src}-${known?.id === inviteMethod?.id ? 'white' : 'grey'}.webp`}
                                    alt={known?.title} width={32} height={32} />
                            </div>
                            <h5>{known?.title}</h5>
                        </li>
                    ))}
                </ul>
                {
                    inviteMethod && inviteMethod?.title === "Referral Code" &&
                    <div className={styles.input}>
                        <BearerTextField
                            colorStyle="gray"
                            label="Invite Code"
                            placeholder="..."
                            type="text"
                            name="invite-code"
                            value={inviteCode}
                            onChange={(e) => setInviteCode(e.target.value)}
                            clear={() => { setInviteCode('') }}
                        />
                    </div>
                }
                <Observer>{() => {
                    return (
                        <>
                            <Button
                                type='submit'
                                className={styles.submit}
                                variant="text"
                                color="primary"
                                fullWidth
                                disableRipple={true}
                                disabled={!checkvalidation()}
                            >
                                Submit
                            </Button>
                        </>
                    )
                }}</Observer>
            </form>
        </div>
    )
});

export default HearAboutBearer;